import React, { useState } from 'react';
import { useApi, api } from '../hooks/useApi';
import useMobile from '../hooks/useMobile';
import { useTheme } from '../context/ThemeContext';

const MEAL_TYPES = [
  { key:'frokost',   label:'🍳 Frokost' },
  { key:'lunsj',     label:'🥗 Lunsj' },
  { key:'middag',    label:'🍽 Middag' },
  { key:'kveldsmat', label:'🫖 Kveldsmat' },
];
const DAYS_NO = ['Man','Tir','Ons','Tor','Fre','Lør','Søn'];

function getWeekDates(offset = 0) {
  const now  = new Date();
  const day  = now.getDay() === 0 ? 6 : now.getDay() - 1;
  const mon  = new Date(now); mon.setDate(now.getDate() - day + offset * 7);
  return Array.from({length:7}, (_, i) => {
    const d = new Date(mon); d.setDate(mon.getDate() + i);
    return d.toISOString().slice(0,10);
  });
}

function fmt(dateStr) {
  const d = new Date(dateStr + 'T12:00:00');
  return `${d.getDate()}. ${d.toLocaleDateString('nb-NO',{month:'short'})}`;
}

export default function MealPage() {
  const isMobile = useMobile();
  const { dark } = useTheme();
  const [weekOffset, setWeekOffset] = useState(0);
  const [adding, setAdding] = useState(null); // {date, meal_type}
  const [form, setForm]     = useState({ name:'', note:'' });

  const dates = getWeekDates(weekOffset);
  const from  = dates[0];
  const to    = dates[6];
  const { data: meals, refresh } = useApi(`/api/meals?from=${from}&to=${to}`, [weekOffset]);

  const mealsFor = (date, type) => (meals||[]).filter(m => m.date===date && m.meal_type===type);

  const save = async e => {
    e.preventDefault();
    await api.post('/api/meals', { ...form, date: adding.date, meal_type: adding.meal_type });
    setAdding(null); setForm({ name:'', note:'' }); refresh();
  };

  const del = async id => { await api.delete(`/api/meals/${id}`); refresh(); };

  const isToday = d => d === new Date().toISOString().slice(0,10);
  const todayStr = new Date().toISOString().slice(0,10);

  const pageBg = dark ? '#0A0818' : '#EDE8FF';
  const txt    = dark ? '#E8E8F8' : '#1A1A35';
  const sub    = dark ? '#9090B8' : '#888';
  const border = dark ? 'rgba(255,255,255,.07)' : 'rgba(124,111,247,0.12)';
  const glassInp = { width:'100%', padding:'12px 14px', borderRadius:12, border:'1px solid '+(dark?'rgba(255,255,255,0.12)':'rgba(124,111,247,0.2)'), background: dark?'rgba(255,255,255,0.08)':'rgba(255,255,255,0.7)', color:txt, fontSize:14, fontFamily:'inherit', outline:'none', marginBottom:10, boxSizing:'border-box' };

  if (isMobile) return (
    <div style={{ background:pageBg, minHeight:'100%', fontFamily:"'Plus Jakarta Sans',sans-serif" }}>

      {/* Gradient Hero Header */}
      <div style={{
        background: dark
          ? 'linear-gradient(145deg, #2D1B69 0%, #1A1245 55%, #0D0B1E 100%)'
          : 'linear-gradient(145deg, #7C6FF7 0%, #9358E8 45%, #5E4AE3 100%)',
        padding: '52px 20px 20px',
        position: 'relative',
        overflow: 'hidden',
      }}>
        <div style={{ position:'absolute', top:-40, right:-40, width:160, height:160, borderRadius:'50%', background:'rgba(255,255,255,0.06)', pointerEvents:'none' }}/>
        <div style={{ position:'absolute', bottom:-60, left:-20, width:140, height:140, borderRadius:'50%', background:'rgba(255,255,255,0.04)', pointerEvents:'none' }}/>
        <div style={{ position:'relative', zIndex:1 }}>
          <div style={{ marginBottom:14 }}>
            <div style={{ fontSize:13, color:'rgba(255,255,255,0.65)', fontWeight:500, marginBottom:2 }}>Famora</div>
            <div style={{ fontSize:24, fontWeight:800, color:'#fff' }}>Matplan</div>
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:10 }}>
            <button onClick={()=>setWeekOffset(o=>o-1)} style={{ background:'rgba(255,255,255,0.15)', border:'none', borderRadius:10, width:36, height:36, fontSize:18, color:'#fff', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>‹</button>
            <span style={{ flex:1, textAlign:'center', fontSize:14, fontWeight:700, color:'rgba(255,255,255,0.9)' }}>
              {weekOffset===0?'Denne uken':weekOffset===1?'Neste uke':weekOffset===-1?'Forrige uke':`Uke +${weekOffset}`} · {fmt(dates[0])}–{fmt(dates[6])}
            </span>
            <button onClick={()=>setWeekOffset(o=>o+1)} style={{ background:'rgba(255,255,255,0.15)', border:'none', borderRadius:10, width:36, height:36, fontSize:18, color:'#fff', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>›</button>
          </div>
        </div>
      </div>

      {/* Dager */}
      <div style={{ padding:'12px 16px 80px' }}>
        {dates.map(date => {
          return (
            <div key={date} className="glass-card" style={{ marginBottom:10, overflow:'hidden', padding:0, border: isToday(date)?'1px solid rgba(124,111,247,0.5)':undefined }}>
              <div style={{ padding:'10px 16px 8px', display:'flex', alignItems:'center', justifyContent:'space-between', borderBottom:'1px solid '+border }}>
                <div style={{ fontSize:14, fontWeight:800, color: isToday(date)?'#7C6FF7':txt }}>
                  {new Date(date+'T12:00:00').toLocaleDateString('nb-NO',{weekday:'long',day:'numeric',month:'short'})}
                  {isToday(date)&&<span style={{ marginLeft:8, fontSize:11, background:'linear-gradient(135deg,#7C6FF7,#9358E8)', color:'#fff', borderRadius:20, padding:'2px 8px' }}>I dag</span>}
                </div>
              </div>
              {MEAL_TYPES.map((mt,i) => {
                const items = mealsFor(date, mt.key);
                return (
                  <div key={mt.key} style={{ borderTop: i>0?'1px solid '+border:'none', padding:'8px 16px', display:'flex', alignItems:'center', gap:10 }}>
                    <span style={{ fontSize:12, fontWeight:700, color:sub, width:80, flexShrink:0 }}>{mt.label}</span>
                    <div style={{ flex:1, display:'flex', flexWrap:'wrap', gap:6 }}>
                      {items.map(m => (
                        <div key={m.id} style={{ background:'linear-gradient(135deg,#7C6FF7,#9358E8)', color:'#fff', borderRadius:20, padding:'4px 12px', fontSize:13, fontWeight:600, display:'flex', alignItems:'center', gap:6 }}>
                          {m.name}
                          <button onClick={()=>del(m.id)} style={{ background:'none', border:'none', color:'rgba(255,255,255,0.7)', cursor:'pointer', fontSize:14, padding:0, lineHeight:1 }}>✕</button>
                        </div>
                      ))}
                      <button onClick={()=>setAdding({date,meal_type:mt.key})} style={{ background:dark?'rgba(255,255,255,0.08)':'rgba(124,111,247,0.10)', border:'none', borderRadius:20, padding:'4px 10px', fontSize:12, color:sub, cursor:'pointer' }}>+ Legg til</button>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>

      {/* Modal for å legge til */}
      {adding && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.6)', zIndex:200, display:'flex', alignItems:'flex-end' }}
          onClick={()=>setAdding(null)}>
          <div style={{ background: dark?'#1A1245':'#fff', borderRadius:'20px 20px 0 0', padding:20, width:'100%' }} onClick={e=>e.stopPropagation()}>
            <div style={{ fontSize:16, fontWeight:800, color:txt, marginBottom:14 }}>
              {MEAL_TYPES.find(m=>m.key===adding.meal_type)?.label} · {fmt(adding.date)}
            </div>
            <form onSubmit={save}>
              <input autoFocus value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} required
                placeholder="Rett (f.eks. Pasta bolognese)" style={{...glassInp}}/>
              <input value={form.note} onChange={e=>setForm(f=>({...f,note:e.target.value}))}
                placeholder="Notat (valgfritt)" style={{...glassInp}}/>
              <div style={{ display:'flex', gap:10 }}>
                <button type="submit" style={{ flex:1, background:'linear-gradient(135deg,#7C6FF7,#9358E8)', color:'#fff', border:'none', borderRadius:12, padding:13, fontWeight:700, fontSize:15, cursor:'pointer' }}>Lagre</button>
                <button type="button" onClick={()=>setAdding(null)} style={{ flex:1, background:dark?'rgba(255,255,255,0.08)':'rgba(124,111,247,0.10)', color:txt, border:'none', borderRadius:12, padding:13, fontWeight:700, fontSize:15, cursor:'pointer' }}>Avbryt</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );

  return (
    <div style={s.wrap}>
      {/* Ukenavigasjon */}
      <div style={s.weekNav}>
        <button style={s.navBtn} onClick={() => setWeekOffset(o=>o-1)}>‹ Forrige</button>
        <span style={s.weekLabel}>
          {weekOffset === 0 ? 'Denne uken' : weekOffset === 1 ? 'Neste uke' : weekOffset === -1 ? 'Forrige uke' : `Uke +${weekOffset}`}
          {' '}· {fmt(dates[0])} – {fmt(dates[6])}
        </span>
        <button style={s.navBtn} onClick={() => setWeekOffset(o=>o+1)}>Neste ›</button>
      </div>

      {/* Dag-headers */}
      <div style={s.grid}>
        <div style={s.typeCol} /> {/* tom hjørnecelle */}
        {dates.map((d,i) => (
          <div key={d} style={{...s.dayHeader, ...(isToday(d)?s.dayHeaderToday:{})}}>
            <div style={s.dayName}>{DAYS_NO[i]}</div>
            <div style={s.dayDate}>{fmt(d)}</div>
          </div>
        ))}

        {/* Rader per måltidstype */}
        {MEAL_TYPES.map(mt => (
          <React.Fragment key={mt.key}>
            <div style={s.typeCell}>{mt.label}</div>
            {dates.map(d => {
              const items = mealsFor(d, mt.key);
              return (
                <div key={d} style={{...s.cell, ...(isToday(d)?s.cellToday:{})}}>
                  {items.map(m => (
                    <div key={m.id} style={s.mealTag}>
                      <span style={s.mealName}>{m.name}</span>
                      <button style={s.delX} onClick={() => del(m.id)}>✕</button>
                    </div>
                  ))}
                  <button style={s.addBtn}
                    onClick={() => { setAdding({date:d, meal_type:mt.key}); setForm({name:'',note:''}); }}>
                    +
                  </button>
                </div>
              );
            })}
          </React.Fragment>
        ))}
      </div>

      {/* Legg til-modal */}
      {adding && (
        <div style={s.modalBack} onClick={() => setAdding(null)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalTitle}>
              {MEAL_TYPES.find(m=>m.key===adding.meal_type)?.label} · {fmt(adding.date)}
            </div>
            <form onSubmit={save} style={s.form}>
              <input style={s.inp} placeholder="Hva skal du spise?" value={form.name}
                onChange={e => setForm(f=>({...f,name:e.target.value}))} required autoFocus />
              <input style={s.inp} placeholder="Notat (valgfritt)" value={form.note}
                onChange={e => setForm(f=>({...f,note:e.target.value}))} />
              <div style={{display:'flex',gap:8}}>
                <button style={s.saveBtn} type="submit">Legg til</button>
                <button style={s.cancelBtn} type="button" onClick={() => setAdding(null)}>Avbryt</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  wrap:           { display:'flex', flexDirection:'column', gap:14 },
  weekNav:        { display:'flex', alignItems:'center', justifyContent:'space-between', background:'var(--card)', borderRadius:14, padding:'12px 16px', border:'1px solid var(--bdr)' },
  navBtn:         { padding:'7px 14px', borderRadius:9, border:'1px solid var(--bdr)', background:'var(--bg)', color:'#7C6FF7', fontWeight:700, cursor:'pointer', fontSize:13, fontFamily:'inherit' },
  weekLabel:      { fontSize:14, fontWeight:700, color:'var(--txt)' },
  grid:           { display:'grid', gridTemplateColumns:'100px repeat(7, 1fr)', gap:3, overflowX:'auto' },
  typeCol:        { },
  dayHeader:      { background:'var(--card)', borderRadius:10, padding:'8px 4px', textAlign:'center', border:'1px solid var(--bdr)' },
  dayHeaderToday: { background:'#7C6FF7', border:'none' },
  dayName:        { fontSize:11, fontWeight:800, color:'inherit' },
  dayDate:        { fontSize:10, color:'var(--txl)', marginTop:2 },
  typeCell:       { display:'flex', alignItems:'center', fontSize:12, fontWeight:700, color:'var(--txm)', padding:'0 6px' },
  cell:           { background:'var(--card)', borderRadius:10, padding:6, minHeight:60, border:'1px solid var(--bdr)', display:'flex', flexDirection:'column', gap:4 },
  cellToday:      { background:'var(--bg)', borderColor:'var(--bdr)' },
  mealTag:        { display:'flex', alignItems:'center', justifyContent:'space-between', background:'var(--bdr)', borderRadius:6, padding:'3px 7px', gap:4 },
  mealName:       { fontSize:11, fontWeight:600, color:'var(--txt)', flex:1, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' },
  delX:           { background:'none', border:'none', color:'var(--txl)', cursor:'pointer', fontSize:11, padding:0, lineHeight:1, flexShrink:0 },
  addBtn:         { background:'none', border:'1px dashed var(--bdr)', borderRadius:6, color:'var(--txl)', cursor:'pointer', fontSize:16, padding:'1px 0', marginTop:'auto', lineHeight:1.4 },
  modalBack:      { position:'fixed', inset:0, background:'rgba(0,0,0,.4)', zIndex:500, display:'flex', alignItems:'center', justifyContent:'center', padding:16 },
  modal:          { background:'var(--card)', borderRadius:18, padding:24, width:'100%', maxWidth:360, boxShadow:'0 8px 40px rgba(0,0,0,.15)' },
  modalTitle:     { fontSize:15, fontWeight:800, color:'var(--txt)', marginBottom:16 },
  form:           { display:'flex', flexDirection:'column', gap:10 },
  inp:            { padding:'10px 12px', borderRadius:10, border:'1px solid var(--input-bdr)', fontFamily:'inherit', fontSize:14, color:'var(--input-txt)', outline:'none', background:'var(--input-bg)' },
  saveBtn:        { flex:1, padding:'10px', borderRadius:10, border:'none', background:'#7C6FF7', color:'#fff', fontWeight:700, cursor:'pointer', fontSize:14, fontFamily:'inherit' },
  cancelBtn:      { flex:1, padding:'10px', borderRadius:10, border:'1px solid var(--bdr)', background:'var(--card)', color:'var(--txm)', fontWeight:600, cursor:'pointer', fontSize:14, fontFamily:'inherit' },
};
